// Figma-spec colors (4ZdHY8bgfpcTL4REWmZ7sO / 8185:109 Check In)
export const CHECK_IN_COLORS = {
  text: '#383838',
  textSecondary: '#5F6375',
  navy: '#23305F',
  navyLink: '#242D56',
  border: '#E4E6EB',
  surfaceSubtle: '#F7F7F9',
  muted: '#A7A7A7',
  hairline: '#E6E6E9',
  sheetBg: '#FCFCFF',
  green: '#15803D',
  red: '#B42318',
  amber: '#B45309',
  amberSoft: '#FEF4E6',
  redSoft: '#FEF3F2',
  gold: '#FFE733',
  goldText: '#141F33',
  tileBorder: '#ECECEF',
  white: '#FFFFFF',
  white85: 'rgba(255,255,255,0.85)',
  white80: 'rgba(255,255,255,0.8)',
  searchBorder: 'rgba(56,56,56,0.8)',
  rosterBorder: '#E6E6E9',
  rosterDivider: '#F1F1F4',
  rosterShadow: '0px 1px 3px 0px rgba(35,48,95,0.05)',
} as const;
